// Library Methods
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import Navbar from "src/components/shared/navigation/Navbar/Navbar";

// Styles
import { PageContainerWrapper } from "src/styles/mui/muiStylesHelper";

// Invalid page for users without a clinic
const Invalid = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <Navbar canNavigate={false} />
      <Box sx={PageContainerWrapper(theme)}>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          py={10}
          px="24px"
          gap="24px"
          textAlign="center"
        >
          <Typography fontSize="24px" fontWeight={600}>
            {t("Error!")}
          </Typography>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            gap="8px"
          >
            <Typography fontSize="20px">
              {t(
                "Your clinic information could not be retrieved, or your account is not attached to any clinic."
              )}
            </Typography>
            <Typography fontSize="20px">
              {t(
                "Please try logging off and logging in again. If the issue persists, please contact us at"
              )}{" "}
              <b>support@retinalogik.ca</b>.
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Invalid;
